import { faPollH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Empty = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <div
      style={{
        backgroundColor: colors.all.orange,
        padding: "1em",
        width: "fit-content",
        marginLeft: 10,
        borderRadius: 10,
        flexDirection: "row"
      }}
    >
      <FontAwesomeIcon
        icon={faPollH}
        color={colors.all.white}
        size="1x"
        style={{ marginRight: 10 }}
      />
      No more data to show
    </div>
  );
});
export default Empty;
